import { render, staticRenderFns } from "./SalesForecastInputDetail.vue?vue&type=template&id=35680e90&scoped=true"
import script from "./SalesForecastInputDetail.vue?vue&type=script&lang=js"
export * from "./SalesForecastInputDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35680e90",
  null
  
)

export default component.exports